module.exports = __webpack_public_path__ + "static/bg-intro.cc549811.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-intro.jpg
// module id = 227
// module chunks = 35783957827783 95715928098905 172322841747965